module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/icecommonpages/icecommonpages.component.css
// module id = ./src/app/sharedcomponents/icecommonpages/icecommonpages.component.css
// module chunks = main